import { InputOtp } from "primereact/inputotp";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Col, SubTitle, Text, Title } from "../../style/base.style";
import styled from "styled-components";
import { useDictionary } from "../../contexts/dictionary";
import { Colors } from "../../style/colors";
import { ActionButton } from "../buttons/ActionButton";

import { useLocation } from "react-router-dom";
import { FormComponent } from "../form";
import { useFormHandling } from "../../hooks/formUtils";
import { RequestConfigs } from "../../api";
import { useContactType } from "../../contexts/ContactContext";
import { OtpAuth, PhoneAuthNew } from "../../hooks/socialAuth";

interface OTPFormProps {
    type: "phone" | "email";
    method:"login" | "register"
}
export const OTPForm = ({type,method}:OTPFormProps) => {

      const [token, setTokens] = useState();
      const {translate}= useDictionary();
      const navigate = useNavigate();
      const isaxClass = type === "phone" ? "isax-mobile" : "isax-sms";
      const title = type === "phone" ? translate('phone_otp') : translate('email_otp');
      const description = type === "phone" ? translate('otp_sent_to_mobile') : translate('otp_sent_to_email');
      const [combinedServerRes,setCombineServerRes] = useState<ApiResponse | null>(null);

    const {verifyPhoneAndLink} = PhoneAuthNew()

    const {loginWithOtp} = OtpAuth()

    const verifyFunction = method === "register" ? verifyPhoneAndLink : loginWithOtp
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const verificationId = searchParams.get('verificationId');

    const {setContact} = useContactType()
    const {handleClick,serverRes,handleInputChange,formValues} = useFormHandling({requestType: RequestConfigs.updateContact,data:{Phone_Verified:true}})
    const authForm = useFormHandling({requestType: RequestConfigs.socialAuth})

    useEffect(() => {
        if (formValues?.Firebase_Id && method === "register") {
            handleClick()
        } else if(formValues?.Firebase_Id && method === "login") {
            authForm.handleClick()
        }
    }, [formValues])

    useEffect(() => {
        if (serverRes && serverRes.contact) {
            setCombineServerRes(serverRes)
            if(serverRes.succeeded){
                setContact(serverRes.contact)
                navigate('/dashboard')  
            }
        }
    }, [serverRes])

    useEffect(() => {
      if (authForm.serverRes && authForm.serverRes.contact) {
          setCombineServerRes(authForm.serverRes)
          if(authForm.serverRes.succeeded){
              setContact(authForm.serverRes.contact)
              navigate('/dashboard')  
          }
      }
  }, [authForm.serverRes])

    if(!verificationId)
        navigate('/error-500')

    const [seconds, setSeconds] = useState(60);

    useEffect(() => {
        if (seconds > 0) {
            const timerId = setInterval(() => {
                setSeconds(prevSeconds => prevSeconds - 1);
            }, 1000);
            return () => clearInterval(timerId);
        }
    }, [seconds]);

    const verifyProcess = async (value:string) => {
        const result = await verifyFunction(verificationId as string, value)
        const user = result?.data?.user;
        setCombineServerRes(result as ApiResponse)
        if (user) {
            handleInputChange('Firebase_Id', user.uid, true)
            authForm.handleInputChange('Firebase_Id', user.uid, true)
        }
        console.log(result, "result verify")

    }
    
   return (
     <Col $gap={20} $margin="20px 0px" $width="50%" $alignSelf="center">
    <Col $gap={20} $backgroundColor={Colors.whiteBackground} $padding="50px" $width="100%" $borderRadius={10} $border={`1px solid ${Colors.fieldBorder}`} $alignSelf="center" $justifyContent="center" $alignItems="center">
    <div className="container">
      {/* Login Phone Otp */}
      <div className="row justify-content-center">
        <div className="col-lg-5 col-md-6">
          <div className="contact-content">
            <Col>
              <IconContainer>
                    <ImgIcon className={`isax ${isaxClass}`} />
              </IconContainer>
              <div className="otp-sec">
                      <p>
                        <i className="isax isax-clock" />
                        00:{seconds} {translate('secs')}
                      </p>
                    </div>
              
              <Col $gap={10} $width="100%">
                <Title>{title}</Title>
                <FormComponent
                    fields={[]}
                    onChange={() => {}}
                    serverRes={combinedServerRes}/>
                <Text className="mb-0">
                 {description}
                </Text>
              </Col>
              
                
              
         
                <div className="otp-box">
                  <Col style={{ direction: 'ltr' }} className="opt-box" $margin="20px 0 0 0">
                    <InputOtp value={token} onChange={(e: any) => {
                            
                            setTokens(e.value)
                            console.log(e.value.length, "value")
                            if( e.value.length === 6 ){
                                  verifyProcess(e.value)
                            }
                        }} length={6} />
                  </Col>
                  
                  
                </div>

                
                <div className="mb-3">
                  <div className="otp-info">
                    <div className="otp-code">
                      <p>
                        {translate('didnt_get_otp')}{" "}
                        <a href="javascript:void(0);">{translate('resend_code')}</a>
                      </p>
                    </div>
                    
                  </div>
                </div>
                
                  
                    
                  
                
        
            </Col>
          </div>
        </div>
      </div>
      {/* /Login Phone Otp */}
    </div>
    </Col>
    </Col>
   )
   
}

const IconContainer = styled.div`
    width: 74px;
    height: 74px;
    border-radius: 50%;
    background: #0E82FD;
    color: #FFF;
    font-size: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 15px;
`

const ImgIcon = styled.i`
    font-family: 'iconsax' !important;
    speak: never;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    content: "\eb24";

`

